import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {Tag, AvatarList} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {PerformanceReviewReviewee} from 'main/stores/performance_reviews';

const CycleName = observer(({model}) => {
  const {cycle, sharableReviews, sharedReviews, scheduled} = model;

  return (
    <div className='flex align-items-middle'>
      {cycle.name}
      {sharedReviews < sharableReviews && !scheduled && <Tag colour='dodger' className='ml1'>
        <FormattedMessage id='employees.profile.performance.reviews.SHARED_COUNT' values={{sharedReviews, sharableReviews}}/>
      </Tag>}
      {scheduled && <Tag colour='waterloo' className='ml1'>
        <FormattedMessage id='employees.profile.performance.reviews.Scheduled'/>
      </Tag>}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.performance.reviews.Cycle',
    width: 5,
    component: CycleName
  },
  {
    header: 'employees.profile.performance.reviews.Reviewers',
    width: 3,
    render: model => <AvatarList limit={3} moreModalEnabled employees={model.reviewers}/>
  },
  {
    header: 'employees.profile.performance.reviews.Due Date',
    width: 4,
    attribute: 'dueDateView'
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.performance.reviews.No reviews to display'
};

const ReviewsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.performance.reviews.Performance Reviews')}
      columns={COLUMNS}
      showLinks={false}
      showPath={model => `/reviews${model.writeReviewsPath}/employee`}
      proxy={{
        type: 'async',
        endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWEES.FOR_EMPLOYEE.with(employee.id),
        modelType: types.PERFORMANCE_REVIEWS.REVIEWEE,
        model: PerformanceReviewReviewee,
        pageSize: 5
      }}
      localization={LOCALIZATION}
    />
  );
});

export default ReviewsTable;
